<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!-- ボタン -->
      <div>
        <t-row>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.COMMON_CONSTANT.ADD") }}
            </t-button></t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.COMMON_CONSTANT.DELETE") }}
            </t-button></t-col
          >

          <!-- ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓ -->
          <!-- 納品台帳出力機能の追加 -->
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 納品台帳出力 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="outPutBtn"
              @click="outPutClick"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.SEND.OUTPUT_BTN") }}
            </t-button>
          </t-col>
          <!-- ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑ -->
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="13">
                  <div>
                    <!-- 出荷日 -->
                    <t-form-item class="dateLabelWidth" label-width="180px">
                      <span slot="label">
                        <div style="margin-top: 1px">
                          <t-radio-group
                            v-model="sendDateLabel"
                            size="small"
                            style="margin-right: 5px"
                          >
                            <t-radio-button label="1">{{
                              $t("resource.SEND.SEND_DATE")
                            }}</t-radio-button>
                            <t-radio-button label="2">{{
                              $t("resource.SEND.REQ_EXPECTED_DATE")
                            }}</t-radio-button>
                          </t-radio-group>
                        </div>
                      </span>

                      <!--日付(開始日) -->
                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 75%; margin-left: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        :editable="false"
                        class="date_icon_center"
                        :clearable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 状態 -->
                  <t-form-item :label="$t('resource.SEND.STATUS')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                      clearable
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="3">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="18" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxlength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="4" class="right">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    ref="clickBtn"
                    class="button_common_search marginRight"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <!-- 検索結果一覧 -->
      <div class="div_content">
        <t-table
          ref="sendTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 状態 -->
          <t-table-column
            prop="sbSendStatus"
            :label="$t('resource.SEND.STATUS')"
            :min-width="
              flexColumnWidthFunc($t('resource.SEND.STATUS'), 'sbSendStatus')
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.sbSendStatus }} </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>

        <!-- 改ページ -->
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="sendTableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { ShowSendEditDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  deleteSendBasicByNo,
  initSendSearchList,
  searchSendBasic,
} from "@/services/send";
import { outputExcelToZip } from "@/services/common";
import {
  formatDateStrToString,
  formatStringToCurrency,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { GetPageDataCount, STR_ZERO } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      dateRange: [],
      searchConditionForm: {
        searchStartDate: "", // 出荷日(開始日)
        searchEndDate: "", // 出荷日(終了日)
        searchStatus: "",
        isSendDate: "",
        searchWord: "",
      },
      sendDateLabel: "1",
      //ターブルデータ
      sendTableData: [],

      // 出荷状態リスト
      statusList: [],
      columns: [
        // 納品No.
        {
          prop: "sbSendNo",
          label: t("resource.SEND.DELIVERY_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 納品日
        {
          prop: "sbSendDate",
          label: t("resource.SEND.DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 得意先
        {
          prop: "sbCusCode",
          label: t("resource.SEND.CUSTOMER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 請求予定日
        {
          prop: "sbRequestExpectedDate",
          label: t("resource.SEND.REQ_EXPECTED_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },

        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // // 顧客出荷
        // {
        //   prop: "sbSendFlg",
        //   label: t("resource.SEND.SEND_FLG"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
        // // 納品書
        // {
        //   prop: "sbDeliveryNoteFlg",
        //   label: t("resource.SEND.DELIVERY_NOTE_FLG"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // 請求状態
        {
          prop: "sbRequestStatus",
          label: t("resource.SEND.REQ_STATUS"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 備考
        {
          prop: "sbRemarks",
          label: t("resource.SEND.REMARKS"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],

      showFlag: false,
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      // データ総数
      sendTableDatalength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    };
  },

  mounted() {
    //画面初期化
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
    setColumnWidth(this.columns, this.sendTableData);
    this.sendTableDatalength = this.sendTableData.length;
  },
  computed: {
    tableData() {
      return this.sendTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  methods: {
    // 画面初期化
    init() {
      this.showFlag = true;
      this.sendTableData = [];
      // 検索条件リストの初期化(有無状態、請求状態、出荷状態、得意先リスト、ユーザーリスト、仕入先リスト)
      initSendSearchList()
        .then((res) => {
          // 出荷状態リスト
          this.statusList = res.sendStatusList;
          //日付初期化
          this.dateInit();
          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    // 「検索」ボタン
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //検索条件の処理
      this.updateSearchForm();
      //検索出荷基本情報
      searchSendBasic(this.searchConditionForm)
        .then((res) => {
          this.sendTableData = res;
          this.sendTableDatalength = this.sendTableData.length;

          // データ処理
          this.dataProcess();
          setColumnWidth(this.columns, this.sendTableData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.clickBtn !== "undefined") {
        // フォーカス削除
        this.$refs.clickBtn.$el.blur();
      }
    },

    //検索条件の調整
    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      //日付チェック区分の設定
      this.searchConditionForm.isSendDate =
        this.sendDateLabel === "1" ? true : false;
      //日付の設定
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = this.dateRange[0];
        this.searchConditionForm.searchEndDate = this.dateRange[1];
      } else {
        this.searchConditionForm.searchStartDate = "";
        this.searchConditionForm.searchEndDate = "";
      }
    },

    //データの処理
    dataProcess() {
      if (this.sendTableData.length >= 1) {
        this.sendTableData.map((item) => {
          if (item.sbSendDate) {
            //出荷日の変換
            item.sbSendDate = formatDateStrToString(item.sbSendDate);
          }

          if (item.sbRequestExpectedDate) {
            //請求予定日
            item.sbRequestExpectedDate = formatDateStrToString(
              item.sbRequestExpectedDate
            );
          }

          if (item.obSumPrice != null) {
            //金額(CNY)
            item.obSumPrice = formatStringToCurrency(parseInt(item.obSumPrice));
          }
          return item;
        });
      }
    },

    // 「新規」ボタン
    addClick() {
      ShowSendEditDialog(
        {
          isAdd: true,
        },
        t("resource.SEND.SEND_EDIT_DIALOG"),
        this.searchClick
      );

      if (typeof this.$refs.addBtn !== "undefined") {
        // フォーカス削除
        this.$refs.addBtn.$el.blur();
      }
    },

    //編集処理
    detailClick(row) {
      ShowSendEditDialog(
        {
          isAdd: false,
          rowData: row,
        },
        t("resource.SEND.SEND_EDIT_DIALOG"),
        this.searchClick
      );
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.sendTableData.selection;

      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        // 新規以外のデータの削除が不可
        for (let index = 0; index < data.length; index++) {
          let dataStatus = data[index].sbSendStatus;

          // //新規以外のデータの削除が不可
          // if (STATUS_NEW != dataStatus) {
          //   deleteFlg = false;
          //   Message.showError(t("message.SEND.NOT_DELETE"));
          //   break;
          // }
          delList.push(data[index].sbSendNo);

          let sbDelFlg = data[index].sbDelFlg;
          if (sbDelFlg != STR_ZERO) {
            Modal.showError("", t("message.SEND.NOT_DELETE_REQUEST"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            deleteFlg = false;
            break;
          }
        }

        //削除可能の場合
        if (deleteFlg) {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
              cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
              showCancelButton: true,
            }
          ).then(() => {
            if (!this.showFlag) {
              this.showFlag = true;
            }
            deleteSendBasicByNo(delList)
              .then(() => {
                //削除成功
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.delBtn !== "undefined") {
        // フォーカス削除
        this.$refs.delBtn.$el.blur();
      }
    },

    // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
    // 納品台帳出力
    outPutClick() {
      this.showFlag = true;
      //検索条件の調整
      this.updateSearchForm();

      //納品台帳情報出力
      outputExcelToZip(
        httpApi.OutPutSendExcel,
        this.searchConditionForm
      ).finally(() => {
        this.showFlag = false;
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      });
    },
    // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑

    //アダプティブ列幅
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.sendTableData);
    },

    //状態の色の設定
    formatStatusColor(row) {
      if (!!row.statusColor) {
        return row.statusColor;
      }
    },

    //毎ページ件数の取得
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    //毎ページ件数の設定
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    //ページング処理
    pageChange(val) {
      this.pageNo = val;
    },

    //テーブルのソート
    tableSort(column) {
      //ソート後、最初のページに戻る
      this.pageNo = 1;
      masterService.tableSort(this.sendTableData, column);
    },
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1;
}
</style>
